import { BaseEntity } from './base';

export enum ActivityJoinedAction {
  CLOCK_IN,
  INVITE,
  CHECK_IN,
  ENROLLMENT_GROUP,
}

export enum MarketingActivityRuleType {
  UNKNOWN,
  CONSTRAINT,
  DETAIL,
}

export enum MarketingActivityRuleKey {
  MA_RULE_PREORDER_CONFIG = 'MA_RULE_PREORDER_CONFIG', // 预付定金活动配置
  MA_RULE_PREORDER_USERS_LIMIT_CONFIG = 'MA_RULE_PREORDER_USERS_LIMIT_CONFIG', // 预付定金活动用户限制
  MA_RULE_USERS_LIMIT_CONFIG = 'MA_RULE_USERS_LIMIT_CONFIG', // 活动用户限制

  MA_RELATION_CLOCK_IN_POINT = 'MA_RELATION_CLOCK_IN_POINT', // 打卡积分奖励 value为对象，schema:RelationClockInPointSchema
  MA_RELATION_PRODUCT = 'MA_RELATION_PRODUCT', // 新积分活动兑换商品
  MA_RELATION_EARN_POINT_WAY_SLM = 'MA_RELATION_EARN_POINT_WAY_SLM', // 新积分活动分销赚积分方法
  MA_RELATION_EARN_POINT_WAY_CHECKIN = 'MA_RELATION_EARN_POINT_WAY_CHECKIN', // 新积分活动签到赚积分方法
  MA_RELATION_LIMITED_TIME_SALE = 'MA_RELATION_LIMITED_TIME_SALE', // 限时特价
  USER_SKU_MAPPING = 'USER_SKU_MAPPING', // 拥有SKU与指定购买SKU的映射
  DETAIL_RESERVATION_COMMON = 'DETAIL_RESERVATION_COMMON', // 预约活动统一配置
  DETAIL_RESERVATION_DISCOUNT = 'DETAIL_RESERVATION_DISCOUNT', // 预约活动班级折扣配置
}
export interface MarketingActivity extends BaseEntity {
  coverImg: string;
  desc: string;
  endTime: string;
  landingUrl: string;
  name: string;
  startTime: string;
  status: number;
  weight: number;
  rules: MarketingActivityRule[];
  type: MarketActivityType;
}

export enum MarketActivityType {
  UNKNOWN,
  POINT, // 积分活动
  PREORDER, // 预付定价购买
  NEW_POINT, // 改版积分
  LIMITED_TIME_SALE, // 限时优惠购买
  RESERVATION, // 预约购买
  SLM_DISCOUNT, // 邀请好友返学费，分销
  GIFT_COURSE, // 赠课，自定义折扣分销
  DOUBLE_11, // 双十一老带新，升级课程，送教具
  SPECIFY_PURCHASE, // 优先购买指定期的SKU
  REFUND_PLUS, // 邀请好友返学费2.0
  CLOCK_IN, // 打卡活动
  GROWTH_SHARE, // 分享成长页，特权购买
}

export interface MarketingActivityRule extends BaseEntity {
  activityId: number;
  remark: string;
  ruleKey: string;
  ruleName: string;
  ruleType: number;
  ruleValue: object;
}
export interface ReservationCommonSchema {
  reservationEndAt: Date; // 预约结束时间
  reservationStartAt: Date; // 预约开始时间
  saleEndAt: Date; // 售卖结束时间
  saleStartAt: Date; // 售卖开始时间
  skuGroupName: string; // 售卖的SkuGroupName
}

export interface ReservationDiscountSchema {
  discounts: {
    amount: number; // 折扣金额
    reservedCount: number; // 预约人数
  }[];
  groupId: number; // 班级ID
}

export interface RuleUserSkuMapping {
  ownedSkuId: number; // 已购买的SKU
  skuId: number; // 可以购买的SKU
}

export interface RuleUsersLimitSchema {
  ownedSkuId: number;
}

export interface ActivityJoinedRecord extends BaseEntity {
  activityId: number;
  quantity: string;
  reason: string;
  scheduledTime?: string;
  source: ActivityJoinedAction;
  sourceId: number;
  readonly userId: number;
}

export enum ActivityRewardStatus {
  SCHEDULED, // 待发放
  SENT, // 已发放
}

export interface UserActivityJoinedRecordWithStatus {
  quantity: number;
  scheduledTime?: Date;
  sourceId: number;
  status: ActivityRewardStatus;
  userId: number;
  createdAt: Date;
  activityId: string;
}

export interface GClockInActivityJoinedRecordWithStatus extends UserActivityJoinedRecordWithStatus {
  clockedInAt?: Date;
}

export interface GSLMActivityJoinedRecordWithStatus extends UserActivityJoinedRecordWithStatus {
  fundedAt?: Date;
}
export interface GCheckInActivityJoinedRecordWithStatus extends UserActivityJoinedRecordWithStatus {}



// WEBPACK FOOTER //
// ./src/types/marketingActivity.ts